import * as React from 'react';
import classnames from 'classnames';

import './oe-checkbox.scss';

interface IProps {
    checked: boolean;
    onChange: (...args) => void;
    classNames?: string;
    label?: string | object;
    renderLabel?: JSX.Element;
    showAfterLabel?: boolean;
    isDisabled?: boolean;
    value?: string;
}

const OECheckbox = (props: IProps) => {
    const { classNames, onChange, label, renderLabel, checked, showAfterLabel = false, value, isDisabled = false} = props;
    const checkboxClasses = classnames('oe-checkbox', classNames, {
        'oe-checkbox--show-after-label': showAfterLabel,
        'disabled': isDisabled
    });

    return (
        <label className={checkboxClasses}>
            {renderLabel || <div className='oe-checkbox__label'>{label}</div>}
            <input
                className={classnames({ 'oe-checkbox--checked': checked })}
                type='checkbox'
                checked={checked}
                onChange={isDisabled ? undefined : onChange}
                value={value}
            />
            <span className='oe-checkbox__checkmark' />
        </label>
    );
};

export { IProps };
export default OECheckbox;
